export default __webpack_public_path__ + "static/media/defient_title2.png";